import storeHelper from '@/store/helper'
import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'
import { GET_ENDPOINT_URL, TOKEN_INSIDE } from '../.env'
import axios from 'axios'

export class MerchantService extends BaseService {
  static async fetch (params = {}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.lead.agency-list-mc'), params)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async get (leadId) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.lead.agency-cus-detail-info'), { leadId })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async getContract (customerId) {
    try {
      const response = await axios.post(storeHelper.getUrl('cnps.scon.contract.get-list-contract-web-agency'), { customerId, limit: 1, page: 1 }, {
        headers: {
          Authorization: 'Bearer ' + TOKEN_INSIDE
        }
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async create (params = {}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.lead.lead-agent-register'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async update (params = {}) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.lead.lead-agent-update'), params)
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async history (leadId) {
    try {
      const response = await this.request({ auth: true }).post(storeHelper.getUrl('cnps.lead.get-action-by-lead-id'), { leadId })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async downloadExampleFileMcAgent(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.vcbho.download-template'),
        body,
        {
          responseType: 'blob',
        }
      )
      return response
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  static async exportListLeads(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.export-lead-for-agent'),
        body,
        {
          responseType: 'blob',
        }
      )
      return response
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async downloadErrorFileMcAgent(body) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.lead.vcbho.download-file-error'),
        body,
        {
          responseType: 'blob',
        }
      )
      return response
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async importFileListMc(formData, extraData) {
      const response = await this.uploadFile(storeHelper.getUrl('cnps.lead.vcbho.import-data'), formData, extraData)
      return response
  }
}
